/** 註冊方式 */
export const RegisterTypeEnum = Object.freeze({
  /** 0: Email */
  Email: 0,
  /** 1: Google */
  Google: 1,
  /** 2: Facebook */
  Facebook: 2,
  /** 3: Guest */
  Guest: 3,
  /** 4: Line */
  Line: 4,
})
